'use client'

import { ChevronDown } from 'lucide-react'
import { useTranslations } from 'next-intl'

interface IPricingFAQProps {
  openFaqItems: number[]
  toggleFaqItem: (index: number) => void
}

/**
 * FAQ section for the pricing page with collapsible question/answer items
 */
export function PricingFAQ({ openFaqItems, toggleFaqItem }: IPricingFAQProps) {
  const t = useTranslations('pricing-v3')

  const faqData = [
    { question: t('faq.q1.question'), answer: t('faq.q1.answer') },
    { question: t('faq.q2.question'), answer: t('faq.q2.answer') },
    { question: t('faq.q3.question'), answer: t('faq.q3.answer') },
    { question: t('faq.q4.question'), answer: t('faq.q4.answer') },
    { question: t('faq.q5.question'), answer: t('faq.q5.answer') },
    { question: t('faq.q6.question'), answer: t('faq.q6.answer') },
    { question: t('faq.q7.question'), answer: t('faq.q7.answer') },
    { question: t('faq.q8.question'), answer: t('faq.q8.answer') },
  ]

  return (
    <section className="container mx-auto px-4 py-16">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {t('faq.title')}
          </h2>
          <p className="text-white/80 text-lg">{t('faq.subtitle')}</p>
        </div>

        <div className="space-y-4">
          {faqData.map((faq, index) => (
            <div
              key={faq.question}
              className="bg-white/10 border-none rounded-[20px]"
            >
              <button
                type="button"
                onClick={() => toggleFaqItem(index)}
                className="w-full p-6 text-left flex items-center justify-between rounded-[20px] my-0"
              >
                <h3 className="text-lg font-semibold text-white pr-4">
                  {faq.question}
                </h3>
                <ChevronDown
                  className={`w-5 h-5 text-white/60 transition-transform duration-200 flex-shrink-0 ${
                    openFaqItems.includes(index) ? 'rotate-180' : ''
                  }`}
                />
              </button>
              {openFaqItems.includes(index) && (
                <div className="px-6 pb-6">
                  <p className="text-white/80 text-base leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-12" />
      </div>
    </section>
  )
}
